import { OlCommissionFilters } from '../../types/models/ol/commission/ol-commission'

export const transformOlCommissionFiltersToUrl = (filters?: OlCommissionFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.periods) searchParams.set('periods', filters.periods.join(','))
  if (filters.olId) searchParams.set('ol', filters.olId.toString())
  if (filters.products) searchParams.set('products', filters.products.join(','))
  if (filters.formulas) searchParams.set('formulas', filters.formulas.join(','))
  if (filters.durationsInDays)
    searchParams.set('durationsInDays', filters.durationsInDays.toString())

  return searchParams.toString()
}

export const transformUrlToOlCommissionFilters = (
  searchParams: URLSearchParams
): OlCommissionFilters => {
  const filters: OlCommissionFilters = {}

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',').map(Number)

  const products = searchParams.get('products')
  if (products) filters.products = products.split(',').map(Number)

  const olId = searchParams.get('ol')
  if (olId) filters.olId = parseInt(olId)

  const formulas = searchParams.get('formulas')
  if (formulas) filters.formulas = formulas.split(',').map(Number)

  const durationsInDays = searchParams.get('durationsInDays')
  if (durationsInDays) filters.durationsInDays = durationsInDays.split(',').map(Number)
  return filters
}
